import React from "react"
import { Link } from "gatsby"

const InfoPosicion = ({ description }) => {
  const text = description
  const descripcion = text?.replace(/ style="\w+[-\w+:; ,().#&'\\]+"/g, "")
  return (
    <section className="container mx-auto px-6 pb-20">
      <div className="flex flex-col md:flex-row flex-wrap">
        <div className="w-full md:w-1/3 pb-4">
          <h4 className="text-3xl font-medium">About us:</h4>
        </div>
        <div className="w-full md:w-2/3">
          <ul className="list-disc list-inside pb-8">
            <li className="pb-4"><b>We work</b> with the latest technologies and digital tools.</li>
            <li className="pb-4"><b>We optimize</b> processes with the most advanced technologies.</li>
            <li className="pb-4"><b>We verify</b> the background according to the client's specifications.</li>
            <li className="pb-4"><b>We prepare</b> our talents for efficient incorporation.</li>
          </ul>
        </div>
        <div className="w-full md:w-1/3 pb-4">
          <h4 className="text-3xl font-medium">About you:</h4>
        </div>
        <div className="w-full md:w-2/3 pb-8" dangerouslySetInnerHTML={{ __html: descripcion }} />
        <Link to="/careers/open-seat/" className="btn hover:text-variant py-2 px-4 rounded-lg transition duration-300 ease-in-out hover:text-white mx-auto block hover:bg-secondary">Back to Jobs</Link>
      </div>
    </section>
  )
}
export default InfoPosicion